import { deleteBook } from "../actions";

const deletedBook = (id) => async (dispatch) => {
  const URL = `https://assignment4-bookstore-server-tanviranindo.glitch.me/books/${id}`;

  const response = await fetch(URL, { method: "DELETE" });

  if (response.status === 200) {
    dispatch(deleteBook(id));
  }
};

export default deletedBook;
